import { render, staticRenderFns } from "./AppActivities.vue?vue&type=template&id=63f21c4e&"
import script from "./AppActivities.vue?vue&type=script&lang=js&"
export * from "./AppActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports